(function () {
  function setupIEFallback() {
    const ua = window.navigator.userAgent;
    if (ua.indexOf("MSIE ") < 0 && ua.indexOf("Trident/") < 0) return;

    const variantPicker = document.querySelector(
      "variant-selects[data-section]",
    );
    if (!variantPicker) return;

    const sectionId = variantPicker.dataset.section;
    const hiddenInput = document.querySelector(
      `#product-form-${sectionId} input[name="id"]`,
    );
    const noScriptSource = document.querySelector(
      `.product-form__noscript-wrapper-${sectionId}`,
    );
    if (!hiddenInput || !noScriptSource) return;

    const noScriptInputWrapper = document.createElement("div");
    noScriptInputWrapper.innerHTML = noScriptSource.textContent;
    variantPicker.outerHTML = noScriptInputWrapper.outerHTML;

    document
      .querySelector(`#Variants-${sectionId}`)
      ?.addEventListener("change", function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
  }

  function autoSelectPhantomIfUnavailable() {
    const section = document.querySelector(".product-main--section");
    if (section?.dataset.productAvailable !== "false") return;

    const params = new URLSearchParams(window.location.search);
    if (params.has("variant")) return;

    const variantSelects = document.querySelector("variant-selects");
    if (!variantSelects) return;

    variantSelects
      .querySelector('input[value="PHANTOM"]')
      ?.parentElement.click();
    variantSelects.dispatchEvent(new Event("change"));
  }

  function clickFirstFilterIfNoPickerRendered() {
    const section = document.querySelector(".product-main--section");
    if (!section) return;
    if (section.querySelector("variant-selects")) return;

    document.querySelector(".js-cb-filter:not([data-unavailable])")?.click();
  }

  function init() {
    setupIEFallback();
    autoSelectPhantomIfUnavailable();
    clickFirstFilterIfNoPickerRendered();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
